var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDhlQrcodeOnBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFCC01",
    strokeWidth: 1.3,
    fill: "#FFF",
    x: 0.65,
    y: 0.65,
    width: 69.7,
    height: 69.7,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 8h2v2h-2zM8 8v15h15V8H8zm12.857 12.857H10.143V10.143h10.714v10.714zM40.556 23.273V21.09h2.222v2.182H45v-4.364h-4.444v-4.364h2.222v-2.181h-2.222v-2.182h-2.224v2.182H36.11V8h-6.666v2.182H25v2.182h4.444v2.181h2.223v2.182h2.222v-2.182h4.443v4.364H36.11v2.182h2.222v2.182H36.11V21.09h-2.222v2.182h-2.222v-4.364h-2.222v6.546h2.223v2.181h4.444v-2.181h4.445v4.363h2.222V32H45v-4.364h-2.222v-4.363h-2.222zm-6.667-10.91h-2.222v-2.181h2.222v2.182zM48 8v15h15V8H48zm12.857 12.857H50.143V10.143h10.714v10.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h7v7h-7zM52 12h7v7h-7zM28 17h2v2h-2zM34 17h2v2h-2zM26 19h2v7h-2zM17 26h9v2.25h-4.5v2.25H26V35h-2.25v-2.25h-4.5V35H17v2.25h-2.25V44H12.5v-4.5H8V35h4.5v-2.25H8V30.5h4.5v-2.25h2.25v4.5H17zM47.25 26h4.5v2.2H54v6.6h-2.25v-2.2H49.5v2.2h-2.25V37H45v-4.4h2.25zM58 26h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 28h4.5v4.333h2.25v-2.166H34v2.166h2.25v-2.166h4.5V34.5H43v2.167h-2.25v6.5h-4.5V47.5H34v4.333h-2.25v-2.166h-4.5V54H25V43.167h2.25V47.5h2.25v-2.167h2.25v-2.166H34V41h4.5v-2.168h-2.25v-2.165h2.25V34.5H34v2.167h-2.25V34.5H29.5v2.167H25V34.5h2.25v-4.333H25zM21 35h2v2h-2zM17 37h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.857 37H32v6.75h-2.143V41.5h-4.286v2.25H23.43V41.5h-2.143v2.25h2.143V46h-4.286v-2.25H17V41.5h2.143v-2.25h10.714zM43 37h2v2h2v2h-4zM8 43h4v2H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6 34.333V30h-2.2v8.666h-2.2v2.167H52v-2.167h2.2v-2.167H52v-2.167h-2.2V36.5h-2.2v2.167h2.2v4.333H41v8.668h2.2v2.166h4.4V56H52v-2.167h2.2v-2.166h2.2V56h2.2v-8.667h-4.4v-2.166h4.4V36.5H63v-2.167h-4.4zM52 51.667h-6.6v-6.5H52v6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 46h4v2h-4zM36 48h2v4h-2zM47 48h2v2h-2zM8 48v15h15V48H8zm12.857 12.857H10.143V50.143h10.714v10.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 52h7v7h-7zM34 52h2v2h-2zM39 52h2v2h-2zM28 54h2.25v2.25h2.25V54h2.25v2.25H37v2.25h-2.25v2.25H37V63h-6.75v-2.25h2.25V58.5H28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 54h2v2h-2zM40.334 54h2.333v2.25H45V63h-7v-2.25h2.334V58.5H38v-2.25h2.334zM61 54h2v2h-2zM54.429 56h2.142v2.333h2.143V56h2.143v4.667H63V63h-6.429v-2.333H48v-2.334h6.429z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhlQrcodeOnBtn);
export default __webpack_public_path__ + "static/media/dhl_qrcode_on_btn.7122e81476b86df0f8eb269dfa59df67.svg";
export { ForwardRef as ReactComponent };